<template>
  <div style="position: relative;">
    <el-dialog 
      custom-class="station_cus_dialog"
      :modal-append-to-body="false"
      width="550px" 
      top="20px"
      :visible.sync="stationDialogVisible" 
      :modal="false">
      <iframe width="100%" height="100%" :src=" `/yangchen_station/?station_id=${station.station_id}&uid=1526&showMap=0&timep=${timeType}&data_type=${dataType}&start=${$moment(valueTime[0]).unix()}&end=${$moment(valueTime[1]).unix()}&data_calied_type=${calied_type}` " frameborder="0"></iframe>
    </el-dialog>
  </div>
</template>

<script>
export default{
  data(){
    return{

    }
  },
  props:[
    'station',
    'dataType',
    'timeType',
    'stationDialogType',
    'stationDialogVisibleP',
    'valueTime',
    'calied_type'
  ],
  mounted() {
    console.log(this.station)
  },
  computed: {
    stationDialogVisible:{
      get() {
        return this.stationDialogVisibleP
      },
      set(v) {
        this.$emit("changeVisible", v)
      }
    }
  }
}
</script>

<style >
  .station_cus_dialog > .el-dialog__body {
    height: 650px;
    width: 550px;
  }
</style>


// WEBPACK FOOTER //
// src/components/StationDialog.vue